module.exports = __webpack_public_path__ + "img/INNOVATIV.0e52922b.png";